const ICONS = { success: "✓", error: "✕", info: "ℹ", warning: "⚠" };
const COLORS = {
  success: "#0F6E56",
  error: "#A32D2D",
  info: "#185FA5",
  warning: "#BA7517",
};

function showToast(type, msg, duration = 2000) {
  let area = document.getElementById("toast-area");
  if (!area) {
    area = document.createElement("div");
    area.id = "toast-area";
    area.style.cssText =
      "position:fixed;top:30px;right:24px;z-index:99999;display:flex;flex-direction:column;gap:8px;align-items:flex-end;pointer-events:none";
    document.body.appendChild(area);
  }
  const t = document.createElement("div");
  t.style.cssText = `display:flex;align-items:center;gap:10px;padding:12px 16px;border-radius:10px;font-size:13px;font-weight:500;color:#fff;background:${COLORS[type]};min-width:220px;box-shadow:0 6px 20px rgba(0,0,0,0.18);opacity:0;transform:translateY(10px);transition:opacity .25s,transform .25s;pointer-events:auto`;
  t.innerHTML = `<span style="font-size:15px">${ICONS[type]}</span><span>${msg}</span>`;
  area.appendChild(t);
  requestAnimationFrame(() => {
    t.style.opacity = "1";
    t.style.transform = "translateY(0)";
  });
  setTimeout(() => {
    t.style.opacity = "0";
    t.style.transform = "translateY(10px)";
    setTimeout(() => t.remove(), 300);
  }, duration);
}

const toast = {
  success: (msg, duration) => showToast("success", msg, duration),
  error: (msg, duration) => showToast("error", msg, duration),
  info: (msg, duration) => showToast("info", msg, duration),
  warning: (msg, duration) => showToast("warning", msg, duration),
};

export default toast;
